import { useTranslation } from "react-i18next";
import {
  ContactDetailsSectionBreadcrumbs,
  ContactDetailsSectionBreadcrumbsProps,
} from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useMemo, useState } from "react";
import { FilePlus2 } from "lucide-react";

export interface FilesSectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const FilesSection = ({ enduser }: FilesSectionProps) => {
  const [showUploadFile, setShowUploadFile] = useState(false);
  const { t } = useTranslation("contacts");

  const { breadcrumbs, actionButtons } = useMemo<
    Pick<ContactDetailsSectionBreadcrumbsProps, "breadcrumbs" | "actionButtons">
  >(() => {
    const breadcrumbs: ContactDetailsSectionBreadcrumbsProps["breadcrumbs"] = [
      {
        title: t("Files"),
        onClick: showUploadFile ? () => setShowUploadFile(false) : undefined,
      },
    ];
    if (showUploadFile) {
      breadcrumbs.push({ title: t("Upload File") });
    }

    const actionButtons: ContactDetailsSectionBreadcrumbsProps["actionButtons"] = showUploadFile
      ? undefined
      : [
          {
            hoverLabel: t("Upload File"),
            onClick: () => setShowUploadFile(true),
            icon: FilePlus2,
          },
        ];

    return { breadcrumbs, actionButtons };
  }, [showUploadFile, t]);

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs
        enduserId={enduser.id}
        breadcrumbs={breadcrumbs}
        actionButtons={actionButtons}
      />
      {showUploadFile ? (
        <ContactDetailsSections.UploadFileForm contactId={enduser.id} onUpload={() => setShowUploadFile(false)} />
      ) : (
        <ContactDetailsSections.FilesSection contact={enduser} />
      )}
    </div>
  );
};
